/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * An API Key without the secret.
 */
export interface ApiKey {
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    expiration: Date;
    /** SubjectID of API key. */
    subjectId: string;
}
